import ChatList from "@/components/ChatList"

type ChatsProps = {
  onActiveChatChange: (chatJid: string) => void
}

const Archive = ({ onActiveChatChange }: ChatsProps) => {
  return <ChatList onActiveChatChange={onActiveChatChange} isArchive />
}

export default Archive
